import React from 'react';
import styled from 'styled-components';
import { cores } from '../../../../styles/styleUtils';

const KPIContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
`;

const KPIBox = styled.div`
  background-color: ${cores.cinzaClaro};
  border: 1px solid #E2E4E8;
  border-radius: 5px;
  padding: 16px;
  text-align: center;
`;

const KPITitle = styled.h4`
  color: ${cores.cinzaMedio};
  font-size: 1rem;
  margin-bottom: 8px;
`;

const KPIData = styled.span`
  font-size: 1.5rem;
  color: ${cores.chumbo};
  font-weight: bold;
`;

const KPISection = ({totaisDespesas}) => {
  // Dummy data
  const percentageAchieved = 75;
  const totalReceivables = 'R$ 15.000,00';

  return (
    <div>
      <KPIBox>
        <KPITitle>Total Despesa do Mês</KPITitle>
        <KPIData>{totaisDespesas.totalPago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</KPIData>
      </KPIBox>

      <KPIContainer>
        <KPIBox>
          <KPITitle>Total - Custos Fixos</KPITitle>
          <KPIData>{totaisDespesas.totalCustoFixos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</KPIData>
        </KPIBox>
        <KPIBox>
          <KPITitle>Total - Equipe Comercial</KPITitle>
          <KPIData>{totaisDespesas.totalEquipeComercial.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</KPIData>
        </KPIBox>
      </KPIContainer>
    </div>
  );
};

export default KPISection;